module.exports = __webpack_public_path__ + "img/dynamic-5.d83f59e5.png";